export default __webpack_public_path__ + "static/media/AppStoreBadgeWhite.b03dd0f9.svg";